export default __webpack_public_path__ + "static/media/velov.88e61dc9.svg";